window.cartType = 'mini-cart';
window.addToCartCallback = (cart) => {
  window.SLIDECART_UPDATE(cart);
  window.SLIDECART_OPEN();
};

/* Gallery swap on Customall products.
   - Initial: Customall live preview shown (#artwork-preview), theme
     main slider hidden by CSS default. Thumbnails always visible.
   - User clicks a thumbnail: show theme main slider (so the chosen
     product photo is visible), hide Customall preview.
   - User clicks/changes a personalisation control: swap back to
     Customall preview, hide theme main. */
(function () {
  var LOG = '[gallery-swap]';
  var wired = false;

  function getEls() {
    return {
      preview: document.querySelector('#artwork-preview'),
      mainSlider: document.querySelector(
        '.product__media-wrapper media-gallery slider-component[id^="GalleryViewer"]'
      ),
      thumbs: document.querySelector(
        '.product__media-wrapper media-gallery slider-component[id^="GalleryThumbnails"]'
      ),
      personalization: document.querySelector('.ctm-customize-product'),
    };
  }

  function showCustomallPreview() {
    var els = getEls();
    if (els.preview) els.preview.classList.remove('customall-preview-hidden');
    if (els.mainSlider) els.mainSlider.classList.remove('theme-main-shown');
  }

  function showThemeMain() {
    var els = getEls();
    if (els.preview) els.preview.classList.add('customall-preview-hidden');
    if (els.mainSlider) els.mainSlider.classList.add('theme-main-shown');
  }

  function wire() {
    if (wired) return;
    var els = getEls();
    if (!els.preview || !els.mainSlider || !els.thumbs || !els.personalization) return;
    wired = true;

    /* Thumbnail click → show theme main image (with chosen slide). */
    els.thumbs.addEventListener('click', showThemeMain, { capture: true });

    /* Personalisation interaction → show Customall live preview. */
    ['click', 'change', 'input'].forEach(function (evt) {
      els.personalization.addEventListener(evt, showCustomallPreview, { capture: true });
    });

    /* Default state: Customall preview visible (CSS handles this). */
    showCustomallPreview();
    console.log(LOG, 'wired: thumb→theme, personalisation→preview');
  }

  function init() {
    wire();
    if (wired) return;
    var observer = new MutationObserver(wire);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Customall replaces the main product price HTML with a stripped-down
   <span class="money">€27.00</span> and removes the .price__regular that
   the lev plugin normally injects "(X.XX лв)" into. Re-add a Bulgarian
   formatted price + lev equivalent so the price reads like Customily. */
(function () {
  var BGN_RATE = 1.95583; /* EUR → BGN fixed peg (Bulgaria) */
  var LOG = '[price-lev-restorer]';

  function format(num, locale) {
    return num.toFixed(2).replace('.', locale === 'bg' ? ',' : '.');
  }

  function restorePrice() {
    var priceWrapper = document.querySelector('.price.price--large');
    if (!priceWrapper) return;
    /* If we've already added the lev suffix, skip. */
    if (priceWrapper.querySelector('.price-bgn-restored')) return;

    var moneySpan = priceWrapper.querySelector('.price__sale .money, .money');
    if (!moneySpan) return;

    /* Parse the EUR price out of the visible text. Match digits + decimal. */
    var match = (moneySpan.textContent || '').match(/[\d.,]+/);
    if (!match) return;
    var eur = parseFloat(match[0].replace(',', '.'));
    if (!isFinite(eur)) return;

    var bgn = eur * BGN_RATE;
    /* Rewrite the visible price text to Bulgarian comma-decimal format. */
    moneySpan.textContent = '€' + format(eur, 'bg');

    /* Append the lev equivalent as a small grey suffix. */
    var bgnSpan = document.createElement('span');
    bgnSpan.className = 'price-bgn-restored';
    bgnSpan.textContent = ' (' + format(bgn, 'en') + ' лв)';
    bgnSpan.style.color = '#666';
    bgnSpan.style.fontSize = '0.9em';
    bgnSpan.style.fontWeight = 'normal';
    bgnSpan.style.marginLeft = '4px';
    moneySpan.parentNode.appendChild(bgnSpan);
    console.log(LOG, 'price restored to', moneySpan.textContent + bgnSpan.textContent);
  }

  function init() {
    restorePrice();
    /* Watch for re-renders (variant change, etc.) */
    var observer = new MutationObserver(restorePrice);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Two tweaks for Customall product pages:
   1. Move .cart-qty (Customall's quantity dropdown) ABOVE .ctm-customize-product
      so it matches the Customily layout (qty before personalization options).
   2. Replace the raw <select> inside .cart-qty with a +/− stepper UI that
      drives the underlying select via change events — Customall keeps reading
      its own form, but the user sees a stepper matching the Dawn theme look. */
(function () {
  var LOG = '[customall-fixes]';
  var QUANTITY_SELECTOR = '.cart-qty';
  var CARD_SELECTOR = '.ctm-customize-product';

  var attempts = 0;
  var loggedOnce = false;

  function moveQuantityAboveCard() {
    var quantity = document.querySelector(QUANTITY_SELECTOR);
    var card = document.querySelector(CARD_SELECTOR);
    if (!quantity || !card) return false;
    if (card.previousElementSibling === quantity) return true;
    try {
      card.parentNode.insertBefore(quantity, card);
      console.log(LOG, 'moved .cart-qty before card');
      return true;
    } catch (e) {
      console.error(LOG, 'move failed:', e);
      return false;
    }
  }

  function injectStepper() {
    var cartQty = document.querySelector('.cart-qty');
    if (!cartQty) return;
    var select = cartQty.querySelector('select.form-select, select');
    if (!select) return;
    /* Already injected? (re-renders may remove our stepper — re-inject below.) */
    if (cartQty.querySelector('.cart-qty-stepper')) return;

    var stepper = document.createElement('div');
    stepper.className = 'cart-qty-stepper';

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'cart-qty-stepper__btn cart-qty-stepper__btn--minus';
    minus.setAttribute('aria-label', 'Намали количество');
    minus.innerHTML = '<svg viewBox="0 0 10 2" width="10" height="2" aria-hidden="true"><rect width="10" height="2" rx="1" fill="currentColor"/></svg>';

    var valueEl = document.createElement('span');
    valueEl.className = 'cart-qty-stepper__value';

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'cart-qty-stepper__btn cart-qty-stepper__btn--plus';
    plus.setAttribute('aria-label', 'Увеличи количество');
    plus.innerHTML = '<svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true"><rect x="4" width="2" height="10" rx="1" fill="currentColor"/><rect y="4" width="10" height="2" rx="1" fill="currentColor"/></svg>';

    stepper.appendChild(minus);
    stepper.appendChild(valueEl);
    stepper.appendChild(plus);
    cartQty.appendChild(stepper);

    function refresh() {
      var opt = select.options[select.selectedIndex];
      valueEl.textContent = opt ? (opt.textContent || '').trim() : '1';
      minus.disabled = select.selectedIndex <= 0;
      plus.disabled = select.selectedIndex >= select.options.length - 1;
    }

    function changeBy(delta) {
      var newIdx = select.selectedIndex + delta;
      if (newIdx < 0 || newIdx >= select.options.length) return;
      select.selectedIndex = newIdx;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
      refresh();
    }

    minus.addEventListener('click', function () { changeBy(-1); });
    plus.addEventListener('click', function () { changeBy(1); });
    select.addEventListener('change', refresh);
    refresh();
    console.log(LOG, 'stepper injected');
  }

  function tick() {
    attempts++;
    moveQuantityAboveCard();
    injectStepper();

    if (!loggedOnce) {
      var cartQty = document.querySelector('.cart-qty');
      var card = document.querySelector('.ctm-customize-product');
      if (cartQty && card) {
        loggedOnce = true;
        console.log(LOG, 'init complete (cart-qty + card present)');
      }
    }
  }

  function init() {
    console.log(LOG, 'init');
    tick();
    var poll = setInterval(function () {
      tick();
      if (attempts >= 100) {
        clearInterval(poll);
        console.log(LOG, 'poll finished');
      }
    }, 200);

    /* MutationObserver catches late re-renders (variant change, modal close). */
    var observer = new MutationObserver(function () { tick(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
